import { render, staticRenderFns } from "./PublicExamCreation.vue?vue&type=template&id=5ddcd822"
import script from "./PublicExamCreation.vue?vue&type=script&lang=js"
export * from "./PublicExamCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports